export default __webpack_public_path__ + "static/media/Armguards of the Milites Templi.ddb0224b.jpg";